// 暂未使用
const isNullOrEmpty = function(val) {
    if (val == null || val == "" || typeof val == undefined) {
        return true;
    } else {
        return false;
    }
};


/**
 * 身份证脱敏
 * @param {String} idNo - 身份证号
 * @returns {String} 脱敏后的身份证号
 */
export function maskIdNo(idNo) {
    if (!idNo || idNo.length < 10) return idNo;
    // 保留前6位和后4位，中间用*替换
    return idNo.substring(0, 6) + '********' + idNo.substring(idNo.length - 4);
}

/**
 * 手机号脱敏
 * @param {String} phone - 手机号
 * @returns {String} 脱敏后的手机号
 */
export function maskPhone(phone) {
    if (!phone || phone.length < 7) return phone;
    return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4);
}

/**
 * 姓名脱敏
 * @param {String} name - 姓名
 * @returns {String} 脱敏后的姓名
 */
export function maskName(name) {
    if (!name || name.length === 0) return name;
    if (name.length === 1) return '*';
    if (name.length === 2) return name.charAt(0) + '*';
    // 三个字及以上，保留首尾
    return name.charAt(0) + '*'.repeat(name.length - 2) + name.charAt(name.length - 1);
}

export { isNullOrEmpty,};



// WEBPACK FOOTER //
// ./src/filters/index.js